import { MutableValue } from "../api/mutable-value.interface";

export default class BulkProjectPlushieType implements MutableValue {
  public isNew = true;

  constructor(private fId: string, private fName: string) {
    [fId, fName].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  public get id(): string {
    return this.fId;
  }

  public get name(): string {
    return this.fName;
  }
}
